// Valeurs par défaut des filtres de la page Leads auto — source unique.
// Module pur (aucun import) : importable depuis les helpers de la cartouche
// et depuis jest sans tirer axios / jotai. Sert aussi de « valeur vide » de
// chaque champ (désactivation d'un preset, retrait d'un jeton) : `null` pour
// isFinalized et isEstimated, `[]` pour les tableaux, `""` pour les chaînes.
export const LEAD_AUTO_FILTERS_DEFAULT = {
  terms: "",
  products: Object.freeze(["AUTO"]),
  statuses: Object.freeze([]),
  assignedTo: Object.freeze([]),
  isFinalized: null,
  // Étape 2 du formulaire (PER-2428) : « estimée » = première étape complète,
  // « finalisée » = seconde étape complète. Les deux clés se combinent.
  isEstimated: null,
  beginAt: "",
  endAt: "",
  prochaineTache: "",
  // État de l'agent de tarification sur la demande (PER-2433) : valeurs
  // d'état graal, ou « aucun » = jamais intervenu. Vide = pas de filtre.
  agentEtats: Object.freeze([]),
  devisDepose: null,
  page: 1,
};
